export default function Marquee({ items, separator = "///" }) {
  const line = items.join(`  ${separator}  `) + `  ${separator}  `;
  return (
    <div className="relative w-full overflow-hidden py-4 select-none" data-testid="skills-marquee">
      <div className="marquee-track font-mono text-sm md:text-base tracking-[0.3em] text-[#8A9AAB] whitespace-nowrap">
        <span className="mr-8">{line}</span>
        <span className="mr-8">{line}</span>
      </div>
    </div>
  );
}
